module.exports = __webpack_public_path__ + "img/bg_login.b8f3dcb4.jpeg";